<template>
    <div class="main-div">
        <div class="count">
            <p>License Count</p>
            <PrimeSelect v-model="store.licenseCount" :options="licenseOptions" optionLabel="name" optionValue="value" placeholder="Select License Count" class="w-16" />
        </div>
    </div>
</template>
<script setup lang="ts">
import { useSubscribeStore } from '~/stores/components/modals/subscription-modal';
import { SubscriptionType } from '~/types/licenses/licenses';

const store = useSubscribeStore();

const licenseOptions = Array.from({ length: 10 }, (_, i) => ({ name: (i + 1).toString(), value: i + 1 }));

watch(
    () => store.licenseCount,
    (licenseCount) => {
        if (licenseCount === 1) {
            store.selectedUserType = SubscriptionType.INDIVIDUAL;
        } else if (licenseCount === 2) {
            store.selectedUserType = SubscriptionType.COUPLES;
        } else if (licenseCount >= 3) {
            store.selectedUserType = SubscriptionType.FAMILY;
        }
    }
);
</script>
<style lang="scss" scoped>
.main-div {

    @apply lg:w-auto w-full; 
    .count {
        @apply flex items-center gap-1 self-stretch justify-between;

        p {
            @apply text-zinc-900 font-inter text-xl font-semibold;
        }
    }

    .gift-code {
        @apply flex pb-6 items-center gap-1 self-stretch;

        p {
            @apply text-zinc-900 font-inter text-xl font-semibold leading-8;
        }
    }

    .input-div {
        @apply flex flex-col items-start gap-1.5 self-stretch;

        .input-gift-code {
            @apply flex rounded-sm border border-zinc-300 w-full;
        }

        .message {
            @apply flex items-center gap-2 py-1 self-stretch;

            p {
                @apply text-zinc-500 font-inter text-sm font-medium leading-5;
            }

            .check-icon {
                @apply w-5 h-5 text-green-500;
            }
        }
    }
}
.input-giftcode {
    @apply rounded-l bg-white w-full px-3 py-2 outline-none rounded-l-md;
}
.btn-apply {
    @apply rounded-r text-zinc-700 bg-white px-4 py-2 font-inter text-sm;
    @apply font-semibold leading-5 rounded-r-md;
}
.divider-h {
    @apply w-px bg-zinc-300;
}
.divider {
    @apply border border-zinc-300 w-full border-t my-9;
}
.inputtext-root,
.p-btn-root-primary {
    border: 0px solid var(--Zinc-300, #fff);
}
</style>
